// extracted by mini-css-extract-plugin
export default {"form_error":"clientInfoManagement_form_error__5hpNS"};